import { applicationModules } from './application-modules';
import type { AppEnvironment } from './environment.model';

const authApiUrl = 'https://homol.api.sso.eqgrupo.com.br/api';

export const environment: AppEnvironment = {
  production: true,
  auth: {
    url: authApiUrl,
    storageKey: 'equantis_auth_session',
    loginPath: '/login',
    selectAccessPath: '/select-access',
    applicationModules,
  },
  issuer: {
    url: 'https://homol.admin.issuer.eqgrupo.com.br/api',
  },
  eqauth: {
    url: authApiUrl,
  },
  payment: {
    url: 'https://homol.api.payment.eqgrupo.com.br/api',
  },
};
